// src/common/components/kitList/KitListItem.tsx

import React from "react";
import { SaleItemInterface } from "../../types/types";
import { getImageUri } from "../../utils/functions/getImageUri";
import { formatPriceToLocale } from "../../utils/functions/formatPriceToLocale";
import { useDisplayPrice } from "../../hooks/useDisplayPrice";
import { shortenText } from "../../utils/functions/shortenText";
import { getItemDisplayText } from "../../utils/functions/getItemDisplayText";
import styles from "./KitList.module.scss";

type Props = {
  item: SaleItemInterface;
  quantity: number;
  getCategoryName?: (id: number) => string | undefined;
};

export const KitListItem = ({ item, quantity, getCategoryName }: Props) => {
  const getPrice = useDisplayPrice();
  const displayPrice = getPrice(item.prices);
  const hasPrice = Boolean(displayPrice);

  const firstImage =
    item.files?.find(
      (path) => !path.includes("video_") && !path.includes("poster_"),
    ) ||
    item.files?.find((path) => path.includes("poster_")) ||
    null;

  const displayName = getItemDisplayText(item);

  return (
    <div className={styles.item}>
      <div className={styles.leftBlock}>
        <div className={styles.imageContainer}>
          {firstImage && (
            <img
              className={styles.image}
              src={`${getImageUri()}${firstImage}`}
              alt={item.name}
            />
          )}
        </div>
        <div className={styles.content}>
          <div className={styles.info}>
            <span className={styles.name} title={displayName}>
              {shortenText(displayName, 40)}
            </span>
            {getCategoryName && (
              <span className={styles.category}>
                {getCategoryName(Number(item.categoryId))}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className={styles.rightBlock}>
        <span className={styles.quantity}>× {quantity}</span>
        <span className={styles.price}>
          {hasPrice ? `${formatPriceToLocale(displayPrice)} ₽` : ""}
        </span>
      </div>
    </div>
  );
};